import React from "react";
import { getDsLayoutComponentRenderer } from "@mediaspace/features/layout";

const Kcapture = React.lazy(() => import("@mediaspace/features/kcapture"));

export const render = getDsLayoutComponentRenderer(Kcapture);
